import React from "react";

import AccordionUI from "../../../components/common/AccordionUI";
import { ObjectType } from "../../../types/tableTypes";

export default function PropertyDetails({
  isApplicationSubmitted,
  idx,
  loanType,
  theme,
  translation,
  loanId,
  propType,
  propConfig,
  label,
  loanContextData
}: {
  isApplicationSubmitted: boolean,
  idx: number,
  loanType: string | undefined,
  theme: any,
  translation: any,
  loanId: string | undefined,
  propType: string | undefined,
  propConfig: ObjectType,
  label: string,
  loanContextData: ObjectType,
}) {
  const { propertyDetails, expandLeverageAndTests, setAddressInputValue, setZipCodeInputValue } = loanContextData;

  React.useEffect(() => {
    const currentProperty = propertyDetails?.[idx ?? 0];
    const address = currentProperty?.propertyLocation?.address || "";
    const postalCode = currentProperty?.propertyLocation?.postalCode || "";

    // Functional updaters, not a snapshot of the addressInputValue/
    // zipCodeInputValue props: every property index has its own instance of
    // this component, and they all mount/update in the same render pass.
    // Reading `addressInputValue`/`zipCodeInputValue` from the closure and
    // calling setState with a plain value is a last-writer-wins race — each
    // instance would overwrite the others' just-committed slot with its own
    // stale pre-update copy of the array, corrupting every property's
    // address/zip except whichever instance's effect happened to run last.
    setAddressInputValue((prev: string[]) => {
      const next = [...(prev ?? [])];
      next[idx ?? 0] = address;
      return next;
    });
    setZipCodeInputValue((prev: string[]) => {
      const next = [...(prev ?? [])];
      next[idx ?? 0] = postalCode;
      return next;
    });
  }, [
    propertyDetails?.[idx ?? 0]?.propertyLocation?.address,
    propertyDetails?.[idx ?? 0]?.propertyLocation?.postalCode,
    idx,
  ]);

  return (
    <AccordionUI
      component={propConfig}
      idx={idx}
      label={label ?? "loanDetails"}
      data={propertyDetails}
      expandLeverageAndTests={expandLeverageAndTests}
      isApplicationSubmitted={isApplicationSubmitted}
      loanType={loanType}
      theme={theme}
      translation={translation}
      loanId={loanId}
      propType={propType}
      loanContextData={loanContextData}
    />
  );
}